export default IconLocationPause => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-location-pause" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M13.02 20.04l-3.02 -6.04l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.634 10.062" />
  <path d="M17 17v5" />
  <path d="M21 17v5" />
</svg>`;